import { useContext, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { faCommentAlt, faClock } from "@fortawesome/free-regular-svg-icons";

import { AuthenticationContext } from "../../services/authentication/authentication.context";
import { ellispisis } from "../../helpers/utility-methods";
import { formatUrl } from "../../helpers/parse-url";
import { parseReplyTime } from "../../helpers/parse-time";
import { useGlobalMedic } from "../../services/global-medic/gobal-medic.context";



export const CommentUnit = ({ post, indx, setLoading }) => {

    const { token, userData } = useContext(AuthenticationContext);
    const { deleteComment } = useGlobalMedic();

    const [openReplies, setopenReplies] = useState([]);
    const [menuShown, setMenuShown] = useState(null);

    

    const toggleReply = (indx) => {
        if (openReplies.includes(indx)) {
            setopenReplies((psts) => psts.filter((v) => v !== indx));
        } else {
            setopenReplies((psts) => ([...psts, indx]));
        }
    }

    const handleDeleteComment = async () => {
        setLoading(true)
        const resp = await deleteComment(indx, token);
        //console.log(resp);
        if (resp?.error) {
            alert(resp?.error);
            setLoading(false);
            return;
        }
        alert(resp?.message);
        setLoading(false);
        window.location.reload();
    }



    return (
        <div
            className='post-item-cmt'
            onContextMenu={() => ''}
        >
            <div className='author-info'>
                <img
                    src={formatUrl(post?.author?.avatar)}
                    className='author-avatar'
                />
                <div className='author-name'>
                    {post?.author?.username}
                </div>
                <div className="action-box">
                    <button
                        className="tr-btn"
                        onClick={() => setMenuShown(indx)}
                    >
                        <FontAwesomeIcon icon={faEllipsisVertical} />
                    </button>

                </div>
            </div>
            {menuShown === indx && (
                <div className="menu-list">
                    <button
                        className="comm-menu-btn tr-btn"
                        onClick={() => setMenuShown()}
                    >
                        Close
                    </button>
                    {post?.author._id === userData?._id &&
                        <button 
                            className="comm-menu-btn tr-btn"
                        >
                            Edit comment
                        </button>
                    }
                    {post?.author._id === userData?._id &&
                        <button
                            className="comm-menu-btn tr-btn"
                            onClick={async () => await handleDeleteComment()}
                        >
                            Delete Comment
                        </button>
                    }
                    {post?.author._id !== userData?._id &&
                        <button className="comm-menu-btn tr-btn">Report</button>
                    }
                </div>
            )}
            <div className='post-title'>{post?.title}</div>
            <div
                className="post-content"
                dangerouslySetInnerHTML={{
                    __html: post?.content?.length < 200 || openReplies.includes(indx) ?
                        post?.content :
                        ellispisis(post?.content, 200)
                }}
            />

            <button
                className="more"
                onClick={() => toggleReply(indx)}
            >
                {openReplies.includes(indx) ? 'See less' : 'See more'}
            </button>


            <div>
                {post?.media?.image &&
                    <img
                        src={formatUrl(post?.media?.image)}
                        className='post-image'
                    />
                }
            </div>
           
            <div className='reaction-box'>
                <button
                    className="reaction-buttons"
                    disabled
                >

                    <FontAwesomeIcon
                        icon={faClock}
                        style={{ marginRight: 8 }}
                    />
                    <span className='react-cnt'>
                        {parseReplyTime(post?.createdAt)}
                    </span>
                </button>
              
                <button className="reaction-buttons">
                    <FontAwesomeIcon icon={faCommentAlt} />
                </button>
            </div>

        </div>
    )
}
